jQuery(function($) {

  $('.form__select').each(function() {
    var container = $(this);
    var text = $('.form__select__text', container);
    var select = $('select', container);
    var selectedText = $('option:selected', select).text();
    text.text(selectedText);
    select.on('change', function() {
      var selectedText = $('option:selected', select).text();
      text.text(selectedText);
    });
  });

});
